export default "__VITE_ASSET__t$WJbU8dd$Sqs97xC6pIVQ__"